export const getSafeRedirectUrl = (
	redirectUrl: string | undefined,
	baseUrl: string,
) => {
	if (!redirectUrl) {
		return undefined
	}
	try {
		const url = new URL(redirectUrl, baseUrl)
		return url.protocol === 'https:' || url.protocol === 'http:'
			? url.href
			: undefined
	} catch {
		return undefined
	}
}
